module.exports = __webpack_public_path__ + "static/media/profile-style-img3.03f5d762.png";